import { createSelector } from 'reselect';

import type { RequestHistoryPreviewState } from './slice';

/**
 * The selector for the `RequestHistoryPreview` state store slice
 */
export const getRequestHistoryPreviewSlice = (
  state: any,
): RequestHistoryPreviewState => state.RequestHistoryPreview;

export const selectActiveRequests = createSelector(
  getRequestHistoryPreviewSlice,
  ({ activeRequests }) => activeRequests,
);

export const selectDataSubjectActiveCount = createSelector(
  getRequestHistoryPreviewSlice,
  ({ dataSubjectActiveCount }) => dataSubjectActiveCount,
);

export const selectRequestId = createSelector(
  getRequestHistoryPreviewSlice,
  ({ requestId }) => requestId,
);

export const selectCurrentActiveRequest = createSelector(
  getRequestHistoryPreviewSlice,
  ({ activeRequests, requestId }) =>
    activeRequests.find(({ id }) => id === requestId),
);
